import { render, staticRenderFns } from "./RecruitmentForm.vue?vue&type=template&id=78c9950c&scoped=true"
import script from "./RecruitmentForm.vue?vue&type=script&lang=js"
export * from "./RecruitmentForm.vue?vue&type=script&lang=js"
import style0 from "./RecruitmentForm.vue?vue&type=style&index=0&id=78c9950c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c9950c",
  null
  
)

export default component.exports